import { SxProps, Theme } from '@mui/material';

export const DOT_SIZE = 18;
export const LINE_WIDTH = 3;
export const GAP_BETWEEN_EVENTS = 100;

export const eventCard = (isSelected: boolean): SxProps<Theme> => ({
  p: 2,
  backgroundColor: isSelected ? 'action.hover' : 'background.paper',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
  },
  width: '40%',
  alignSelf: 'center',
});

export const desktopEventDot = (isSelected: boolean): SxProps<Theme> => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: DOT_SIZE,
  height: DOT_SIZE,
  borderRadius: '50%',
  border: `${LINE_WIDTH}px solid`,
  borderColor: 'primary.main',
  bgcolor: isSelected ? 'primary.main' : 'background.paper',
  zIndex: 2,
});

export const desktopEventLine = (): SxProps<Theme> => ({
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  width: LINE_WIDTH,
  backgroundColor: 'primary.main',
  zIndex: 1,
  top: `calc(50% + ${DOT_SIZE / 2}px)`,
  height: GAP_BETWEEN_EVENTS,
});

export const eventContainer = (isLeft: boolean): SxProps<Theme> => ({
  position: 'relative',
  display: 'flex',
  justifyContent: isLeft ? 'flex-end' : 'flex-start',
  width: '100%',
  minHeight: `${GAP_BETWEEN_EVENTS}px`,
});

export const mobileEventContainer = (isLast: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'flex-start',
  position: 'relative',
  mb: isLast ? 0 : 5,
  pl: 2.5,
});

export const mobileEventDot = (isSelected: boolean): SxProps<Theme> => ({
  position: 'absolute',
  left: 11,
  top: 4,
  width: DOT_SIZE - 2,
  height: DOT_SIZE - 2,
  borderRadius: '50%',
  border: `${LINE_WIDTH}px solid`,
  borderColor: 'primary.main',
  bgcolor: isSelected ? 'primary.main' : 'background.paper',
  zIndex: 2,
});

export const mobileEventLine = (): SxProps<Theme> => ({
  position: 'absolute',
  left: 20,
  top: DOT_SIZE + 2,
  width: LINE_WIDTH,
  height: 'calc(100% + 24px)',
  backgroundColor: 'primary.main',
  zIndex: 1,
});

export const mobileEventCard = (isSelected: boolean): SxProps<Theme> => ({
  flex: 1,
  ml: 5,
  ...eventCard(isSelected),
  width: 'auto',
  alignSelf: 'flex-start',
});

export const dialogContent = (isMobile: boolean): SxProps<Theme> => ({
  maxHeight: isMobile ? '100%' : '70vh',
  overflowY: 'auto',
  px: isMobile ? 1 : 3,
  py: 2,
});

export const dialogTitle = (isMobile: boolean): SxProps<Theme> => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'sticky',
  top: 0,
  backgroundColor: isMobile ? 'primary.main' : 'background.paper',
  bgcolor: 'primary.main',
  color: 'common.white',
  zIndex: 10,
  py: isMobile ? 1.5 : 2,
  px: isMobile ? 2 : 3,
  borderBottom: isMobile ? 'none' : 1,
  borderColor: 'divider',
  borderRadius: isMobile ? 'none' : '8px 8px 0 0',
});

export const dialogCloseButton = (isMobile: boolean): SxProps<Theme> => ({
  position: 'absolute',
  right: isMobile ? 8 : 16,
  color: isMobile ? 'primary.contrastText' : 'inherit',
});

export const getEventCardProps = (
  index: number,
  eventId: number,
  selectedId: number | null,
  eventsLength: number
) => ({
  isLeft: index % 2 === 0,
  isSelected: selectedId === eventId,
  isLast: index === eventsLength - 1,
});

export const timelineDialogStyles: {
  button: SxProps<Theme>;
  title: SxProps<Theme>;
  titleBox: SxProps<Theme>;
  actionButton: SxProps<Theme>;
  desktopCard: SxProps<Theme>;
  cardTitle: SxProps<Theme>;
  cardText: SxProps<Theme>;
  mobileCard: SxProps<Theme>;
} = {
  button: {
    whiteSpace: 'nowrap',
    px: 2,
    py: 1,
  },
  title: {
    flexGrow: 1,
    textAlign: 'center',
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5,
  },
  actionButton: {
    justifyContent: 'center',
  },
  desktopCard: {
    position: 'relative',
    width: '100%',
    pt: 2,
  },
  cardTitle: {
    fontWeight: 600,
  },
  cardText: {
    mt: 1,
  },
  mobileCard: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    py: 2,
  },
};
